// colors
export const accentColor = "#196ecf";
export const accentColorTransparent = "#0e203790";
export const helperGrey = "#d0d0d0";
export const titleColor = "#ffffff";
export const labelColor = "#fff";

// font sizes
export const titleSize = "1.5em";
export const subtitleSize = "1.2em";
export const labelSize = ".8em;";
export const optionSize = "1em";
export const paraSize = "1em";

// borders
export const accentBorder2px = `2px solid ${accentColor}`;
export const accentBorder1px = `1px solid ${accentColor}`;
export const whiteBorder2px = `2px solid #fff`;
export const titleBorder = `1px solid #fff`;
export const greyBorder = `1px solid ${helperGrey}`;
export const borderRadius = '4px';

// margins
export const navMargining = '50px';